import { render, staticRenderFns } from "./DeleteSosDialog.vue?vue&type=template&id=effbd6bc&"
import script from "./DeleteSosDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteSosDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports